"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyFolder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const EmptyFolderSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#empty-folder__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#CCD4FF",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      d: "M15.8 10.4V9.201a.4.4 0 0 0-.4-.4H9.8a.2.2 0 0 1-.2-.2V8a.4.4 0 0 0-.4-.4H5.8a.4.4 0 0 0-.4.401V16.4s0 1.2.999 1.2h9a.4.4 0 0 0 .401-.4zL6.4 17.6H16.4c1 0 1-1.2 1-1.2v-5.602a.4.4 0 0 0-.4-.398z",
      opacity: 0.35
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#A5AEFF",
      d: "M6.8 7a.4.4 0 0 1 .4-.4h3.001c.22 0 .4.18.4.4v.602c0 .11.087.198.199.198h5.601c.22 0 .4.18.4.4v7.6c0 .221-.178.4-.398.4H7.199a.4.4 0 0 1-.398-.4z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#171717",
      d: "M7 15.2s0 .8.598.8h8.801a.2.2 0 0 0 .2-.202V8.202A.2.2 0 0 0 16.4 8h-5.6a.4.4 0 0 1-.4-.4v-.602a.2.2 0 0 0-.2-.198h-3A.2.2 0 0 0 7 7zm9.6-7.6c.22 0 .4.18.4.401V16a.4.4 0 0 1-.401.401H7.598c-.998 0-.998-1.2-.998-1.2V6.8c0-.221.18-.4.398-.4H10.4a.4.4 0 0 1 .4.399v.602c0 .11.087.198.199.198z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#171717",
      fillRule: "evenodd",
      d: "M8.2 15.2s0 .8-.6.8v.4h10c1 0 1-1.2 1-1.2V9.6a.4.4 0 0 0-.402-.399H8.601A.4.4 0 0 0 8.2 9.6z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M8.601 15.2s0 .8-.4.8h9.4c.6 0 .6-.8.6-.8V9.8a.2.2 0 0 0-.2-.2H8.8a.2.2 0 0 0-.2.2z",
      clipRule: "evenodd"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "empty-folder__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
const EmptyFolder = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: EmptyFolderSvg
}));
exports.EmptyFolder = EmptyFolder;